




import { createComponent, computed, ref } from "@vue/composition-api";
import SearchResultsCard from "./SearchResultsCard.vue";

interface Props {}

export default createComponent<Props>({
  components: { SearchResultsCard },
  props: {},
  setup(props, ctx) {
    const searchTerm = computed(() => ctx.root.$route.params.term);

    return { searchTerm };
  },
});
